import React from 'react';
import { Link } from 'react-router-dom';
import { countOfferTap } from './OfferTaps';
import { ArrowRight, BadgePercent, CheckCircle2, MessageCircle, Phone } from 'lucide-react';

const BENEFITS = ['Single items to full house moves', 'Choose the help you need', 'Clear quote before you book'];

// Hero incentives: owner-approved 10% phone-booking offer + free quote. No expiry, no countdown.
export const HeroOffer = () => (
  <div data-cta-area="hero-offer">
    <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.04] tracking-tight">
      Removals & Clearances <span className="text-[color:var(--mv-orange-2)]">Made Simple.</span>
    </h1>

    <div className="mt-5 rounded-2xl bg-white text-[color:var(--mv-navy)] p-4 sm:p-5 shadow-xl border-l-4 border-[color:var(--mv-orange)] max-w-xl" data-testid="hero-discount-offer">
      <div className="inline-flex items-center gap-1.5 text-[11px] font-black tracking-[0.18em] uppercase text-[color:var(--mv-orange)]" data-testid="hero-discount-eyebrow">
        <BadgePercent className="w-4 h-4" /> Discounts available
      </div>
      <p className="font-display text-xl sm:text-2xl font-extrabold leading-tight mt-1">Call and book now to save 10% on your booking</p>
      <a href="tel:07985291097" onClick={() => countOfferTap('hero')} className="mt-3 inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-full bg-[color:var(--mv-orange)] hover:bg-orange-600 text-white font-bold px-6 h-12 transition-colors" data-testid="hero-call-save-btn">
        <Phone className="w-4 h-4" /> Call to book & save 10%
      </a>
      <p className="text-xs text-slate-600 mt-2 leading-relaxed">Mention this offer when you call. Your discount will be included in the price agreed before you book.</p>
    </div>

    <div className="mt-5 max-w-xl">
      <div className="font-bold text-lg">Get a free, no-obligation quote</div>
      <div className="text-white/80 text-sm">See your price before you decide. Man and van from £45/hour (2-hour minimum).</div>
      <div className="mt-3 flex flex-wrap gap-3">
        <Link to="/#quote" className="btn-primary" data-testid="hero-free-quote-btn">Get my free quote <ArrowRight className="w-4 h-4" /></Link>
        <a href="https://wa.me/447985291097" target="_blank" rel="noreferrer" className="btn-outline" data-testid="hero-whatsapp-btn"><MessageCircle className="w-4 h-4" /> WhatsApp</a>
      </div>
    </div>

    <ul className="mt-5 grid grid-cols-1 sm:grid-cols-3 gap-2 max-w-xl text-sm" data-testid="hero-benefits">
      {BENEFITS.map((t) => (
        <li key={t} className="flex items-start gap-2 text-white/90"><CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-[color:var(--mv-orange-2)]" />{t}</li>
      ))}
    </ul>
    <p className="mt-3 text-xs text-white/70">Ask about same-day availability.</p>
  </div>
);
